import loadMore from './loadMore'

const install = function(Vue) {
  Vue.directive('load-more', loadMore)
}

if (window.Vue) {
  window['load-more'] = loadMore
  Vue.use(install) // eslint-disable-line
}

loadMore.install = install
export default loadMore



// WEBPACK FOOTER //
// ./src/directive/loadMore/index.js